// @see README.md for full event documentation.

// RFQ Builder - page / step tracking
export const RFQ_BUILDER_PAGE_VIEWED = 'rfq_builder_page_viewed';
export const RFQ_BUILDER_STEP_VIEWED = 'rfq_builder_step_viewed';

// RFQ Builder - document generation
export const RFQ_GENERATION_STARTED = 'rfq_generation_started';
export const RFQ_GENERATION_COMPLETED = 'rfq_generation_completed';
export const RFQ_GENERATION_ERROR = 'rfq_generation_error';

// RFQ Builder - navigation / header
export const RFQ_BUILDER_BACK_CLICKED = 'rfq_builder_back_clicked';
export const RFQ_BUILDER_LEAVE_DRAFT_CONFIRMED =
  'rfq_builder_leave_draft_confirmed';
export const RFQ_BUILDER_LEAVE_DRAFT_CANCELLED =
  'rfq_builder_leave_draft_cancelled';

// RFQ Builder - landing step
export const RFQ_BUILDER_START_CLICKED = 'rfq_builder_start_clicked';
export const RFQ_BUILDER_CREATE_ERROR = 'rfq_builder_create_error';

// RFQ Builder - intro step
export const RFQ_BUILDER_INTRO_CONTINUED = 'rfq_builder_intro_continued';

// RFQ Builder - path selection step
export const RFQ_BUILDER_PATH_SELECTED = 'rfq_builder_path_selected';

// RFQ Builder - file upload flows
export const RFQ_BUILDER_FILES_UPLOAD_COMPLETED =
  'rfq_builder_files_upload_completed';
export const RFQ_BUILDER_IMAGE_SELECTION_COMPLETED =
  'rfq_builder_image_selection_completed';

// RFQ Builder - chat playground
export const RFQ_BUILDER_MESSAGE_SENT = 'rfq_builder_message_sent';
export const RFQ_BUILDER_CHAT_COMPLETED = 'rfq_builder_chat_completed';
export const RFQ_BUILDER_ADD_REFERENCES_OPENED =
  'rfq_builder_add_references_opened';
export const RFQ_BUILDER_CONVERSATION_ERROR = 'rfq_builder_conversation_error';

// RFQ Builder - drawer / document
export const RFQ_DRAWER_OPENED = 'rfq_drawer_opened';
export const RFQ_DRAWER_CLOSED = 'rfq_drawer_closed';
export const RFQ_BUILDER_NAME_EDITED = 'rfq_builder_name_edited';
export const RFQ_BUILDER_DOCUMENT_EDITED = 'rfq_builder_document_edited';
export const RFQ_BUILDER_DOCUMENT_SAVED = 'rfq_builder_document_saved';
export const RFQ_BUILDER_SOURCING_STARTED = 'rfq_builder_sourcing_started';
export const RFQ_BUILDER_CAVELA_DIRECT_SHOWN =
  'rfq_builder_cavela_direct_shown';
export const RFQ_BUILDER_CAVELA_DIRECT_DISMISSED =
  'rfq_builder_cavela_direct_dismissed';
export const RFQ_BUILDER_CAVELA_DIRECT_PURCHASE_COMPLETED =
  'rfq_builder_cavela_direct_purchase_completed';
export const RFQ_BUILDER_CAVELA_DIRECT_QUOTE_REJECTED =
  'rfq_builder_cavela_direct_quote_rejected';
